import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from '../../utils/axiosAdvanced';
import { toast } from "react-toastify";

export const createTrip = createAsyncThunk(
    'tripControl/createTrip',
    async (tripData, thunkAPI) => {
        try {
            const response = await apiClient.post('/create_trip', tripData);
            toast.success("Trip created successfully")
            return response.data;
        } catch (error) {
            console.error('Trip creation error:', error);
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const searchTrip = createAsyncThunk(
    'tripControl/searchTrip',
    async ({
        tripName, tripId,
        truckRegistrationNumber, deviceImei,
        driverName, routeNumber, routeName,
        customer, goodsName,
        plannedStartTimeFrom, plannedStartTimeTo,
        tripStage, activeStatus, endReason
    }, thunkAPI) => {
        console.log("searchTrip", tripName, tripId, truckRegistrationNumber, deviceImei, driverName, routeNumber, routeName, customer, goodsName, plannedStartTimeFrom, plannedStartTimeTo, tripStage, activeStatus, endReason);
        try {
            const requestBody = {};

            if (tripName) requestBody.tripName = tripName;
            if (tripId) requestBody.tripId = tripId;
            if (truckRegistrationNumber) requestBody.truckRegistrationNumber = truckRegistrationNumber;
            if (deviceImei) requestBody.deviceImei = deviceImei;
            if (driverName) requestBody.driverName = driverName;
            if (routeNumber !== undefined) requestBody.routeNumber = routeNumber;
            if (routeName) requestBody.routeName = routeName;
            if (customer) requestBody.customer = customer;
            if (goodsName) requestBody.goodsName = goodsName;
            if (plannedStartTimeFrom) requestBody.plannedStartTimeFrom = plannedStartTimeFrom;
            if (plannedStartTimeTo) requestBody.plannedStartTimeTo = plannedStartTimeTo;
            if (tripStage !== undefined) requestBody.tripStage = tripStage;
            if (activeStatus !== undefined) requestBody.activeStatus = activeStatus;
            if (endReason !== undefined) requestBody.endReason = endReason;

            const apiData = await apiClient.post('/search_trips', requestBody);
            console.log("apiData", apiData);
            return { trips: apiData.data.data };
        } catch (error) {
            console.log("searchTrip error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const cancelTrip = createAsyncThunk(
    'tripControl/cancelTrip',
    async ({ trip, reason }, thunkAPI) => {
        try {
            console.log("cancelTrip", trip._id, reason);
            const apiData = await apiClient.post('/cancel_trip', {
                _id: trip._id,
                reason: reason
            });
            toast.error("Trip cancelled successfully")
            return { updatedTrip: apiData.data.updatedTrip };
        } catch (error) {
            console.log("Cancel trip error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getOneTrip = createAsyncThunk(
    'tripControl/getOneTrip',
    async ({ _id, tripId, deviceImei, erpSystemId }, thunkAPI) => {
        try {
            const requestBody = {};

            if (_id) requestBody._id = _id;
            if (tripId) requestBody.tripId = tripId;
            if (deviceImei) requestBody.deviceImei = deviceImei;
            if (erpSystemId) requestBody.erpSystemId = erpSystemId;

            const apiData = await apiClient.post('/get_one_trip', requestBody);

            if (apiData.data.error) {
                throw new Error(apiData.data.error);
            }
            console.log("getOneTrip", apiData.data.data);
            return { trip: apiData.data.data };
        } catch (error) {
            console.log("Get one trip error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const tripStageSearch = createAsyncThunk(
    'tripControl/tripStageSearch',
    async ({ tripStage }, thunkAPI) => {
        try {
            const apiData = await apiClient.post('/tripstage_search', { tripStage: tripStage });
            console.log("tripStageSearch", tripStage, apiData.data.data);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            }

            return { trips: apiData.data.data };
        } catch (error) {
            console.log("Trip stage search error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getActiveTrips = createAsyncThunk(
    'tripControl/getActiveTrips',
    async (thunkAPI) => {
        try {
            const apiData = await apiClient.post('/get_triplist_active');
            console.log("getActiveTrips", apiData.data.data);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            }

            return { trips: apiData.data.data };
        } catch (error) {
            console.log("Get active trips error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);


export const getTripLog = createAsyncThunk(
    'tripControl/getTripLog',
    async (tripId, thunkAPI) => {
        try {
            // Make GET request with responseType blob to handle file download
            const response = await apiClient.get(`/get_trip_log/${tripId}`, {
                responseType: 'blob'
            });

            // Read the blob as text
            const logContent = await response.data.text();

            return { logContent };

        } catch (error) {
            console.log("Get trip log error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getTripSummary = createAsyncThunk(
    'tripControl/getTripSummary',
    async ({ startDate, endDate }, thunkAPI) => {
        try {
            console.log("Get trip summary", startDate, endDate);
            const response = await apiClient.post(`/get_trip_summary`, { startDate, endDate });
            //console.log("Get trip summary response", response);
            return response.data.data;
        } catch (error) {
            console.log("Get trip summary error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getTripPerformance = createAsyncThunk(
    'tripControl/getTripPerformance',
    async ({ type, startDate, endDate, tripStage }, thunkAPI) => {
        try {
            const requestBody = { type, startDate, endDate };
            if (tripStage) requestBody.tripStage = tripStage;
            const response = await apiClient.post('/trip_performance', requestBody);
            const payload = response.data?.data || response.data;
            const cacheKey = response.data?.cacheKey || null;
            return { ...payload, cacheKey };
        } catch (error) {
            console.log("Get trip performance error", error);
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const exportTripPerformance = createAsyncThunk(
    'tripControl/exportTripPerformance',
    async ({ type, exportType, cacheKey, startDate, endDate, tripStage }, thunkAPI) => {
        try {
            const requestBody = { type, export: exportType };
            if (cacheKey) requestBody.cacheKey = cacheKey;
            if (startDate) requestBody.startDate = startDate;
            if (endDate) requestBody.endDate = endDate;
            if (tripStage) requestBody.tripStage = tripStage;

            const response = await apiClient.post('/trip_performance', requestBody, { responseType: 'blob' });
            const contentType = response.headers?.['content-type'] || '';

            if (contentType.includes('application/json')) {
                const text = await response.data.text();
                const json = JSON.parse(text);
                if (json.cacheExpired) {
                    toast.error("Report cache expired, please refresh and try again.");
                } else if (json.message) {
                    toast.error(json.message);
                } else {
                    toast.error("Unable to download report.");
                }
                return thunkAPI.rejectWithValue(json);
            }

            const fallbackName = `trip_performance_${type}.${exportType === 'pdf' ? 'pdf' : 'xlsx'}`;
            const fileName = response.headers?.["content-disposition"]?.split("filename=")[1] || fallbackName;
            const blob = new Blob([response.data]);

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
            return true;
        } catch (error) {
            console.log("Export trip performance error", error);
            toast.error("Failed to download report.");
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const tripReportPdf = createAsyncThunk(
    'tripControl/tripReportPdf',
    async ({ _id, tripId, deviceImei, erpSystemId }, thunkAPI) => {
        try {
            const requestBody = {};
            if (_id) {
                requestBody._id = _id;
            } else {
                if (tripId) requestBody.tripId = tripId;
                if (deviceImei) requestBody.deviceImei = deviceImei;
                if (erpSystemId) requestBody.erpSystemId = erpSystemId;
            }

            if (Object.keys(requestBody).length === 0) {
                toast.error("Trip identifier missing for report.");
                return thunkAPI.rejectWithValue({ message: "Trip identifier missing." });
            }

            const response = await apiClient.post('/trip_report_pdf', requestBody, { responseType: 'blob' });
            const contentType = response.headers?.['content-type'] || '';

            if (contentType.includes('application/json')) {
                const text = await response.data.text();
                const json = JSON.parse(text);
                if (json.message) {
                    toast.error(json.message);
                } else {
                    toast.error("Unable to download trip report.");
                }
                return thunkAPI.rejectWithValue(json);
            }

            const disposition = response.headers?.['content-disposition'] || '';
            const fileNameMatch = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            const fallbackId = _id || tripId || deviceImei || erpSystemId || 'trip';
            const fileName = fileNameMatch?.[1]?.replace(/['"]/g, '') || `trip_report_${fallbackId}.pdf`;

            const blob = new Blob([response.data], { type: 'application/pdf' });

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
            } else {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }

            return true;
        } catch (error) {
            console.log("Trip report PDF error", error);
            toast.error("Failed to download trip report.");
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const updateRoutePathFromTrip = createAsyncThunk(
    'tripControl/updateRoutePathFromTrip',
    async ({ tripId, name, reason }, thunkAPI) => {
        try {
            const response = await apiClient.post('/update_route_path_from_trip', {
                tripId,
                name,
                reason,
            });

            return response.data;
        } catch (error) {
            console.log("Update route path from trip error", error);
            const message = error.response?.data?.message || error.message || 'Route revision failed';
            return thunkAPI.rejectWithValue({
                success: false,
                message,
            });
        }
    }
);

export const updateTripSettings = createAsyncThunk(
    'tripControl/updateTripSettings',
    async ({ tripId, rules, notifications }, thunkAPI) => {
        try {
            const updateObj = { tripId };
            if (rules !== undefined) updateObj.rules = rules;
            if (notifications !== undefined) updateObj.notifications = notifications;

            const response = await apiClient.post('/update_trip_settings', updateObj);

            if (response.data.error) {
                return thunkAPI.rejectWithValue(response.data.error);
            }
            toast.success("Trip settings updated successfully")
            return response.data.data;
        } catch (error) {
            console.log("Update trip settings error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

/*
router.post('/trip_reprocess', async (req, res) => {
    try {
        const { _id } = req.body;
*/

export const tripReprocess = createAsyncThunk(
    'tripControl/tripReprocess',
    async ({ _id }, thunkAPI) => {
        try {
            const response = await apiClient.post('/trip_reprocess', { _id });
            toast.success("Trip queued for reprocessing")
            return response.data;
        } catch (error) {
            console.log("Trip reprocess error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

/*
router.post('/reset_trip', async (req, res) => {
    try {
        const { tripId } = req.body;
        const trip = await Trip.findOneAndUpdate(
            { tripId },
            { $set: resetFields },
            { new: true }
        );
    */

export const resetTrip = createAsyncThunk(
    'tripControl/resetTrip',
    async ({ trip }, thunkAPI) => {
        try {
            const response = await apiClient.post('/reset_trip', { tripId: trip._id });
            toast.success("Trip reset successfully")
            return response.data;
        } catch (error) {
            console.log("Reset trip error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const resetAllTrips = createAsyncThunk(
    'tripControl/resetAllTrips',
    async (resetPayload, thunkAPI) => {
        try {
            console.log("Reset all trips payload", resetPayload);
            const response = await apiClient.post('/reset_all_trips', resetPayload);
            toast.success("All trips reset successfully")
            return response.data;
        } catch (error) {
            console.log("Reset all trips error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const forceCompleteTrip = createAsyncThunk(
    'tripControl/forceCompleteTrip',
    async ({ tripId, endReason, startTime, endTime }, thunkAPI) => {
        try {
            const response = await apiClient.post('/force_complete_trip', { tripId, endReason, startTime, endTime });
            toast.success("Trip force completed successfully")
            return response.data;
        } catch (error) {
            console.log("Force complete trip error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const getProblemTrips = createAsyncThunk(
    'tripControl/getProblemTrips',
    async (thunkAPI) => {
        try {
            const apiData = await apiClient.post('/problem_triplist');
            console.log("getProblemTrips", apiData.data.data);
            if (apiData.data.error) {
                return thunkAPI.rejectWithValue(apiData.data.error);
            }

            return { trips: apiData.data.data };
        } catch (error) {
            console.log("Get problem trips error", error);
            return thunkAPI.rejectWithValue(error);
        }
    }
);
